import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles, theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import React, { memo, useEffect, useState } from 'react'
import { Link } from 'react-scroll'

export interface Props {
  rooms?: string[]
}

export const Filters = memo(function Filters({ rooms }: Props) {
  if (!rooms) {
    return null
  }

  if (rooms.length < 1) {
    return null
  }

  const [scroll, setScroll] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setScroll(window.scrollY > 180)
    }

    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <Container className={scroll ? 'fixed' : undefined} dial={5} row>
      {rooms.map((item, index) => (
        <Filter
          key={index}
          offset={index % 2 ? -116 : -152}
          spy={true}
          smooth={true}
          to={item}
        >
          {item}
        </Filter>
      ))}
    </Container>
  )
})

const Container = styled(FlexBox)`
  width: 100%;
  background: ${({ theme }) => theme.colors.variants.neutralLight2};
  border-top: 0.0625rem solid ${rgba(theme.colors.variants.neutralDark1, 0.1)};
  position: fixed;
  top: -4.5rem;
  left: 0;
  z-index: 9;
  &.fixed {
    animation: animated 0.3s;
    position: fixed;
    top: 4.5rem;
  }

  @media (max-width: 1199px) {
    display: none;
  }

  @keyframes animated {
    0% {
      top: -4.5rem;
    }
    100% {
      top: 4.5rem;
    }
  }
`

const Filter = styled(Link)`
  ${styles.description}

  cursor: pointer;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  margin: 0 1.5rem;
  opacity: 0.5;
  padding: 0.8125rem 0 0.6875rem;
  transition: 0.4s cubic-bezier(0.25, 1, 0.5, 1);
  &.active,
  &:hover {
    opacity: 1;
  }
`
